import React from 'react';
import { reduxForm, Field } from 'redux-form';

import FormError from 'components/FormError';
import InputField from 'components/InputField';
import CheckboxField from 'components/CheckboxField';
import { isBlank } from 'helpers/validators';

import styles from './styles.module.scss';

let MassTransferForm = ({ handleSubmit, error, carrier }) => {
  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <div className={styles.inputs}>
        {carrier === 'att' && (
          <Field
            component={InputField}
            name="subscription_ids"
            label="Subscription IDs*"
            subText="Comma separated list. Ex.: 101,201"
          />
        )}
        <Field
          component={InputField}
          name="user_profile"
          label="User profile*"
        />
        <Field
          component={InputField}
          name="send_result_to"
          label="Send Result To"
        />
        <Field component={InputField} name="new_pin" label="New Pin" />
        <Field component={CheckboxField} name="rename" label="Rename" />
      </div>

      {error && <FormError error={error} />}
      <button className="btn btn-primary">Mass Transfer</button>
    </form>
  );
};

const validate = (values, { carrier }) => {
  let errors = {};

  let requiredFields;
  if (carrier === 'att') {
    requiredFields = ['subscription_ids', 'user_profile'];
  }

  requiredFields.forEach((field) => {
    if (isBlank(values[field])) {
      errors[field] = 'Required';
    }
  });

  return errors;
};

MassTransferForm = reduxForm({
  form: 'massTransferForm',
  validate,
})(MassTransferForm);

export default MassTransferForm;
